<br>
<div class="col-md-10">
  <p-table #dt [columns]="cols" [value]="institutiongroups" [paginator]="false" [autoLayout]="true">
    <ng-template pTemplate="caption">
      <p class="rubrik">Institution Group</p>
      <div class="d-flex justify-content-start gap-2"><button class="btn border" (click)="resetFilter()" title="Rensa filter">Rensa filter</button><button class="btn border"
            (click)="exportToCSV()">Excel</button><button class="btn border" (click)="addCommittee();">Lägg till</button></div>
      <br>
      <div>
        <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
        <input type="text" #globalfilter pInputText size="50" placeholder="Globalt filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
      <span class="ms-2">Antal poster: {{institutiongroups?.length}}</span>
      
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
          {{col.header}}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
        <th>Action</th>
      </tr>
      <tr>
        <th *ngFor="let col of columns" [ngSwitch]="col.field">
          <input *ngSwitchCase="'name'" pInputText type="text" [value]="dt.filters['name'] ? dt.filters['name'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'description'" pInputText type="text" [value]="dt.filters['description'] ? dt.filters['description'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <!--input *ngSwitchCase="'primary'" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'managed'" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'terminal'" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%"-->
          <p-select appendTo="body" *ngSwitchCase="'primary'" [options]="booleanlist" [autoWidth]="false" [style]="{'maxWidth':'100%'}" (onChange)="dt.filter($event.value, 'primary', 'equals')"></p-select>
          <p-select appendTo="body" *ngSwitchCase="'managed'" [options]="booleanlist" [autoWidth]="false" [style]="{'maxWidth':'100%'}" (onChange)="dt.filter($event.value, 'managed', 'equals')"></p-select>
          <p-select appendTo="body" *ngSwitchCase="'terminal'" [options]="booleanlist" [autoWidth]="false" [style]="{'maxWidth':'100%'}" (onChange)="dt.filter($event.value, 'terminal', 'equals')"></p-select>
        </th>
        <th style="text-align: center;"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-i="rowIndex" let-columns="columns">
      <tr [pSelectableRow]="rowData">
        <td *ngFor="let col of columns">
          <span *ngIf="rowData[col.field]!==true && rowData[col.field]!==false">{{rowData[col.field]}}</span>
          <span *ngIf="col.field !== 'x' && rowData[col.field] === true">
            <i class="fa fa-check" aria-hidden="true" style="color:green;"></i>
          </span>
          <span *ngIf="col.field !== 'x' && rowData[col.field] === false">
            <i class="fa fa-times" aria-hidden="true" style="color:red;"></i>
          </span>
        </td>
        <td><span style="display: inline-block;"><i class="fa fa-trash" style="font-size:12px;" (click)="remove(rowData)" title="Radera aktuell institutionsgrupp"></i><i class="fa fa-edit" style="font-size:12px;margin-left:10px;" (click)="edit(rowData)"
              title="Ändra aktuell institutionsgrupp"></i></span></td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog header="Editera institutionsgrupp" [(visible)]="display" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
  <app-admin-institution-group-edit [formdata]="formdata" (doSave)="saveInstitutionGroup($event)" (doCancel)="cancelEdit()"></app-admin-institution-group-edit>
</p-dialog>

<p-dialog header="Lägg till institutionsgrupp" [(visible)]="displayaddinstitutiongroup" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
  <app-admin-institution-group-add [formdata]="formdata" (doSave)="saveAddInstitutionGroup($event)" (doCancel)="cancelAdd()"></app-admin-institution-group-add>
</p-dialog>